import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function FamilyRequests() {
  const { menu, toggleMobileMenu } = useAppLayout();
  
  const queryClient = useQueryClient();


   const [selectedMember, setSelectedMember] = useState(null);
  
    const [searchModalOpen, setSearchModalOpen] = useState(false);

  const { data: members, isLoading, isError } = useQuery({
    queryKey: ['requestMembers'],
    queryFn: () => 
      axios.get(`${API_URL}/family-members-request-api`, { withCredentials: true })
        .then((response) => response.data),
    staleTime: 0,  // Data is not considered fresh after the request is completed
    cacheTime: Infinity,  // Keep the data cached indefinitely
  });

  //accept request

  const handleAcceptSubmit = async (user_id) => {
    try {
      const res = await axios.post(
        `${API_URL}/family-request-accept-api`,
        { user_id: user_id },
        { withCredentials: true }
      );
  
      if (res.data.Status === "Success") {
        toast.success("Request accepted. Kindly add the member to the tree.");
        
        setSearchModalOpen(false); // Close modal
        queryClient.invalidateQueries(['requestMembers']); // Refresh request list
      } else {
        toast.error("Failed to accept request.");
      }
    } catch (error) {
      console.error("Request failed:", error);
      toast.error("Something went wrong.");
    }
  };


  const handRejectSubmit = async (user_id) => {
    try {
      const res = await axios.post(
        `${API_URL}/family-request-reject-api`,
        { user_id: user_id },
        { withCredentials: true }
      );
  
      if (res.data.Status === "Success") {
        toast.success("Request rejected!");
        
        setSearchModalOpen(false); // Close modal
        queryClient.invalidateQueries(['requestMembers']); // Refresh request list
      } else {
        toast.error("Failed to accept request.");
      }
    } catch (error) {
      console.error("Request failed:", error);
      toast.error("Something went wrong.");
    }
  };
  


  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>

            <div className="row">
              <div className="col-md-12">
              <div class="card">
                <div class="card-body">
                    <p style={{fontWeight: '900', fontSize: '24px'}}>Member request </p>
                            As Family  admin, you will get requests from individuals who want to be part of your family tree. It's your responsibility to evaluate their bios, figure out where they belong in the tree, and then decide whether to approve or deny their request. This helps keep the tree precise and orderly.
                </div>
                </div>
              </div>
            </div>

            
         <div className="row">
      {isLoading ? (
        <div className='loadingspinnerDiv'>
        <div className='loadingspinner'></div>
        
      </div>
      ) : isError ? (
        <p>Error fetching request family members.</p>
      ) : members && members.length > 0 ? (
        members.map((member) => {
          const imagePath = member.image_name
            ? `${API_URL}/images/${member.image_name}`
            : `${API_URL}/images/default.png`;

          return (
            <div key={member.user_id} className="col-md-6">
            <div className="p-3 mb-4 shadow-sm" style={{ backgroundColor: '#fff' }}>

              <div className="row">
                <div className="col-5 col-md-5 d-flex flex-column align-items-center">
                  <img
                    src={`${API_URL}/images/${member.profile_image}`}
                    alt={member.name}
                    className="img-fluid rounded-circle mb-2"
                    style={{ width: '180px', height: '180px', objectFit: 'cover' }}
                  />
                  
                </div>
          
                <div className="col-7 col-md-7">
                  
          
                  <p style={{ marginTop: '4%' }}>
                    <label className="h5 text-uppercase" style={{ fontFamily: 'Helvetica, serif', fontWeight: '600', color: '#000' }}>
                      {member.n_prefix} {member.name} {member.last_name} {member.surname}
                    </label>
                  </p>
                  <p>{member.phone_number}</p>
                  <p>{member.email}</p>
                  
                  <button type="button" className="btn-sm"
                      style={{ border: '1px solid #75B437', background: 'transparent', color: '#000', }}
                      onClick={() => {
                        setSelectedMember(member);      // Set member data
                        setSearchModalOpen(true);       // Open the modal
                      }}
                    >
                      More Info
                    </button>
                  
                </div>
              </div>

              
              <ReactModal isOpen={searchModalOpen} onRequestClose={() => setSearchModalOpen(false)} 
      className="Modal" overlayClassName="Overlay">
      
      <div className="modal-header">
        <h5 className="modal-title">
        {selectedMember && (
        <p class="mb-0 text-uppercase">
                  {selectedMember.n_prefix}{' '}{selectedMember.name}{' '}
                  {selectedMember.last_name} {selectedMember.surname}
                  </p>
                   )}
        </h5>
        <button type="button" className="btn-close modalCloseButton" onClick={() => setSearchModalOpen(false)}></button>
      </div>
    
      <div className="modal-body">
        {selectedMember && (
          <div className="row">
            <div className="col-4 col-md-4">
            
            <button onClick={() => handRejectSubmit(selectedMember.id)} className="btn btn-danger" > Reject Request</button>
            </div>
            <div className="col-4 col-md-4">

            </div>
            <div className="col-4 col-md-4">

            <button onClick={() => handleAcceptSubmit(selectedMember.id)} className="btn btn-primary">
  Accept Request
</button>

            </div>
          </div>
        )}
      </div>
    
     
    </ReactModal>



            </div>
          </div>
          );
        })
      ) : (
        <p>No request found.</p>
      )}
    </div>

            <div className='row end-page-space'></div>
          </div>
        </div>
      </div>
    
  );
}

export default FamilyRequests;
